import React, { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import api from '../services/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const expiresAt = localStorage.getItem('token_expires_at');

    // Verificar se token expirou
    if (token && expiresAt) {
      const expirationDate = new Date(expiresAt);
      if (expirationDate < new Date()) {
        // Token expirado, remover
        localStorage.removeItem('token');
        localStorage.removeItem('token_expires_at');
        setLoading(false);
        return;
      }
    }

    if (token) {
      loadUser();
    } else {
      setLoading(false);
    }
  }, []);

  const loadUser = async () => {
    try {
      const response = await api.get('/auth/me');
      setUser(response.data);
    } catch (error) {
      localStorage.removeItem('token');
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, senha) => {
    try {
      const response = await api.post('/auth/login', { email, senha });
      const { token, user, expiresAt } = response.data;
      localStorage.setItem('token', token);
      if (expiresAt) {
        localStorage.setItem('token_expires_at', expiresAt);
      }
      setUser(user);
      return { success: true };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erro ao fazer login'
      };
    }
  };

  const logout = async () => {
    try {
      // Chamar endpoint de logout para revogar token no servidor
      await api.post('/auth/logout');
    } catch (error) {
      // Mesmo com erro, limpar localmente
      console.warn('Erro ao fazer logout no servidor:', error);
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('token_expires_at');
      setUser(null);
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired
};
